import styled, { css } from 'styled-components';
import { layout } from '@prisjakt/ui-base';
import Button from '@prisjakt/ui-button';
import { NotificationTypes } from './types';

export const Title = styled.span``;

export const Message = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  p {
    margin: 0;
  }
`;

type NotificationProps = {
  type: NotificationTypes;
  hasCloseButton: boolean;
};

export const Notification = styled.div<NotificationProps>(
  props => css`
    border-radius: 5px;
    position: relative;
    padding: ${layout.measurements.spacing100};
    background: ${props.theme.notifications[props.type].bg};
    color: ${props.theme.notifications[props.type].fg};

    ${Message} {
      padding-right: ${props.hasCloseButton
        ? layout.measurements.spacing300
        : '0'};

      &:not(:last-of-type) {
        margin-bottom: ${layout.measurements.spacing100};
      }

      > svg {
        margin: 0 ${layout.measurements.spacing050};
      }
    }
  `
);

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: ${layout.measurements.spacing050};
`;

export const Date = styled.span``;

export const Divider = styled.div`
  &::after {
    content: '|';
    margin-left: ${layout.measurements.spacing025};
    margin-right: ${layout.measurements.spacing025};
  }
`;

export const LinkText = styled.div`
  display: flex;
  align-items: center;
`;

export const Text = styled.span`
  white-space: nowrap;
`;

export const CloseButton = styled(Button)`
  position: absolute;
  top: ${layout.measurements.spacing050};
  right: ${layout.measurements.spacing050};
`;
